import { render, staticRenderFns } from "./ThirdPartyPaymentAccounts.vue?vue&type=template&id=6561a0cb&scoped=true&"
import script from "./ThirdPartyPaymentAccounts.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyPaymentAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6561a0cb",
  null
  
)

export default component.exports